module.exports = __webpack_public_path__ + "img/mask-group-1.da1b1b59.webp";